import { RTU } from '../types/RTU';

export const isMissing = (value: string | null | undefined): boolean =>
  value == null || String(value).trim() === '';

/** ASCII underscore for a missing Producer or Field in dashboard popups. */
export const formatMissingValue = (value: string | null | undefined): string =>
  isMissing(value) ? '_' : String(value);

/** Display-only: exact Evinsys (trim, case-insensitive) becomes Unassigned; missing stays '_'. */
export const formatProducerName = (value: string | null | undefined): string => {
  const formatted = formatMissingValue(value);
  return formatted.trim().toLowerCase() === 'evinsys' ? 'Unassigned' : formatted;
};

/**
 * Normalize omitted producer (`provider`) and `field` to empty strings.
 * Do not invent a company name — keep backend-provided values exactly,
 * including surrounding whitespace and an explicit "Evinsys" when the API
 * actually returned it.
 */
export const withRtuProducerFieldDefaults = <T extends RTU>(rtu: T): T => ({
  ...rtu,
  provider: isMissing(rtu.provider) ? '' : String(rtu.provider),
  field: isMissing(rtu.field) ? '' : String(rtu.field),
});
